import { render } from "./LegalReview.vue?vue&type=template&id=a1a3cd8e"
import script from "./LegalReview.vue?vue&type=script&lang=js"
export * from "./LegalReview.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__